import React from "react";
import { Input } from "antd";
import styled from "styled-components";

// Styled Input Component
const StyledInput = styled(Input)`
  width: 100%;
  max-width: 400px;
  border-radius: 4px;
  overflow: hidden;

  .ant-input {
    border-radius: 4px;
    border-color: #d9d9d9;
    height: 40px;
  }

  .ant-input:focus,
  .ant-input:hover {
    border-color: #40a9ff;
    box-shadow: none;
  }
`;

const CustomSearch = ({ placeholder, onChange, size }) => {
  return (
    <StyledInput
      placeholder={placeholder || "Search..."}
      onChange={(e) => onChange(e.target.value)}
      size={size}
    />
  );
};

export default CustomSearch;
